// extracted by mini-css-extract-plugin
export default {"stroke":"CrossIcon_stroke__F-N0A"};